import { type StateCreator } from 'zustand';

import { type ShareLinkForcedTheme } from '~/components/v2/components/shared/share-link-design/shareLinkColorMode';

export type ShareLinkForcedThemeSlice = {
  /** The theme the mounted share-link surface is forcing; `undefined` = the visitor's preference rules. */
  forcedTheme: ShareLinkForcedTheme | undefined;
  setForcedTheme: (forcedTheme: ShareLinkForcedTheme | undefined) => void;
};

export type CreateShareLinkForcedThemeSlice = (
  initialState: Pick<ShareLinkForcedThemeSlice, 'forcedTheme'>,
) => StateCreator<ShareLinkForcedThemeSlice, [], [], ShareLinkForcedThemeSlice>;

export const createShareLinkForcedThemeSlice: CreateShareLinkForcedThemeSlice = (initialState) => (set) => ({
  forcedTheme: initialState.forcedTheme,
  setForcedTheme: (forcedTheme) => set({ forcedTheme }),
});
